import { render } from "./DeliveryPage.vue?vue&type=template&id=315db978"
import script from "./DeliveryPage.vue?vue&type=script&lang=js"
export * from "./DeliveryPage.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/42/uchowanca/v2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__